import React, { useState } from 'react'

import { fetchApi } from '@hozana/api/fetchApi'
import { useDispatch } from '@hozana/redux/hooks'
import { QA } from '@hozana/tests/constants'

import { Checkbox } from 'elements/input/Checkbox'

import { editCommunityMutation } from 'modules/community/queries'
import type { TCommunity } from 'modules/community/types'
import { useUser } from 'modules/user/hooks/useUser'

export type TCommunityLiveFormProps = {
  community: TCommunity
}

export const CommunityLiveForm: TFC<TCommunityLiveFormProps> = ({ community }) => {
  const me = useUser()
  const [isLive, setLive] = useState(community.isLive)
  const dispatch = useDispatch()

  const onChange: () => void = () => {
    dispatch(fetchApi(editCommunityMutation({ communityId: community.id, isLive: !isLive }))).then(() =>
      setLive(!isLive),
    )
  }

  return me.admin ? (
    <Checkbox value={isLive} onChange={onChange} data-testid={QA.COMMUNITY_PAGE.SUPER_ADMIN_ACTIONS.LIVE_FORM}>
      trans:community:community.live
    </Checkbox>
  ) : null
}
